/* eslint-disable */
import $ from 'jquery';
let ImagesLoaded = require('imagesloaded');
let jQueryBridget = require('jquery-bridget');
let Masonry = require('masonry-layout');
/* eslint-enable */

export default function () {

    jQueryBridget('masonry', Masonry, $);
    jQueryBridget('imagesLoaded', ImagesLoaded, $);

    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    let $grid = $('.grid');
    $grid.imagesLoaded(function () {
        $grid.masonry({
            itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
            columnWidth: '.grid-sizer',
            percentPosition: true
        });
    });
}